import bootLayout from 'static/script/app/boot/boot-layout';
import ToggleElementsUI from 'static/script/app/ui/toggle-elements';
import onReady from 'utils/on-ready';

export default initData => {
    onReady(() => {
        bootLayout(initData);
        ToggleElementsUI.attachTo(document.body);
    });
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/messages.js